//messages.js
export default {
    prime: "Prime",
    email_address: "Email Address",
    email_type: "Email Type",
    new_prime_entity_emails_id: "New Prime Entity Emails Id",
    edit_entity_email: "Edit Entity Email",
    add_entity_email: "Add Entity Email",
    delete_entity_email: "Delete Entity Email",
    entity_emails: "Entity Emails",
    delete_entity_email_confirm: "This action is not reversible!",

    entity_phones_id: "Entity Phones Id",
    object_ref: "Object Ref",
    object_id: "Object Id",
    phone_type: "Phone Type",
    country_id: "Country",
    phone_number: "Phone Number",
    phone_number_formatted: "Phone Number Formatted",
    phone_extension: "Phone Extension",
    prime: "Prime",
    edit_entity_phone: "Edit Entity Phone",
    add_entity_phone: "Add Entity Phone",
    delete_entity_phone: "Delete Entity Phone",
    entity_phones: "Entity Phones",
    delete_entity_phone_confirm: "This action is not reversible!",

    entity_addresses_id: "Entity Addresses Id",
    location_label: "Location Label",
    address1: "Address 1",
    address2: "Address 2",
    city: "City",
    state: "State",
    zip_code: "Zip Code",
    zip_code_ext: "Zip Code Ext",
    address_type: "Address Type",
    prime: "Prime",
    edit_entity_address: "Edit Entity Address",
    add_entity_address: "Add Entity Address",
    delete_entity_address: "Delete Entity Address",
    entity_addresses: "Entity Addresses",
    delete_entity_address_confirm: "This action is not reversible!",

    note_id: "Note Id",
    note: "Note",
    edit_note: "Edit Note",
    add_note: "Add Note",
    delete_note: "Delete Note",
    delete_note_confirm: "This action is not reversible!",
};
